import {
    ClarificationClass,
    Introduction,
    ManualForTeachersClass,
    TextClass,
    WorkbookClass,
    type BookClass,
    Cameos,
    Glossary,
    AppendixTwo,
    FrontMatter,
} from "@circleofa/acim-engine"

export function getColor(category: BookClass["dendrites"][number]) {
    let color = `bg-slate-50`
    let colorDark = `dark:bg-slate-900`
    let text = `Text`
    if (category instanceof TextClass) {
        color = `bg-emerald-100`
        colorDark = `dark:bg-emerald-900`
        text = `Text`
    } else if (category instanceof WorkbookClass) {
        color = `bg-blue-100`
        colorDark = `dark:bg-blue-900`
        text = `Workbook`
    } else if (category instanceof ClarificationClass) {
        color = `bg-red-100`
        colorDark = `dark:bg-red-900`
        text = `Terms`
    } else if (category instanceof ManualForTeachersClass) {
        color = `bg-violet-100`
        colorDark = `dark:bg-violet-900`
        text = `Manual`
    } else if (category instanceof Introduction) {
        color = `bg-orange-100`
        colorDark = `dark:bg-orange-900`
        text = `Intro`
    } else if (category instanceof Cameos) {
        color = `bg-stone-100`
        colorDark = `dark:bg-stone-900`
        text = `Cameo`
    } else if (category instanceof Glossary) {
        color = `bg-stone-100`
        colorDark = `dark:bg-stone-900`
        text = `Glossary`
    } else if (category instanceof AppendixTwo) {
        color = `bg-stone-100`
        colorDark = `dark:bg-stone-900`
        text = `This Edition`
    } else if (category instanceof FrontMatter) {
        color = `bg-stone-100`
        colorDark = `dark:bg-stone-900`
        text = `Front`
    }

    return { color, colorDark, text }
}
